import gsap from 'gsap'
import { lenis } from './lenis'

export const knowledgeHub = () => {
  const el = document.querySelector('.hub')

  if (!el) return

  htmx.on('htmx:beforeRequest', (e) => {
    gsap.to('.hub__entries', { duration: 0.5, opacity: 0 })
  })

  htmx.on('htmx:afterSwap', () => {
    gsap.fromTo('.hub__entries', {
      opacity: 0
    }, {
      opacity: 1,
      duration: 0.5
    })

    lenis.scrollTo('.hub__entries', {
      duration: 1.5,
      offset: -250
    })
  })
}

export default () => {}